export enum ProductGroup {
	WarehouseAccessory = "WarehouseAccessory",
	WrapingMaterials = "WrapingMaterials",
	WarehouseMarking = "WarehouseMarking",
}
